// external imports
import React from 'react';

// local imports
import exportConfig from '../../config';

const SendCapsBackModal = ({
	capturesCurrentlyInQC,
	user,
	qcCat,
	sendingCapsBack,
	setLoading
}) => {

	
	const functionSendCapsBack = () => {
		setLoading(true);
		let cat = qcCat.toLowerCase();

		const commodities = [
			...new Set(capturesCurrentlyInQC.map((item) => item.commodity_id))
		];

		sendingCapsBack.makeRequest(
			`/${cat}/remove_from_queue`,
			'POST',
			{
				commodityIds: commodities.join(','),
				qcUser: `${user.givenName.toLowerCase()}.${user.familyName.toLowerCase()}`,
				captureIds: capturesCurrentlyInQC.map((cap) => cap.capture_id).join(',')
			},
			`captures back to database ..`
		);
	};

	return (
		<div
			className="modal modal-lg fade"
			id="sendCapsBackModal"
			tabIndex="-1"
			aria-labelledby="sendCapsBackModalLabel"
			aria-hidden="true"
			style={{ marginTop: '20vh' }}
		>
			<div className="modal-dialog">
				<div className="modal-content" style={{ marginLeft: '40px' }}>
					<div
						className="modal-header text-light"
						style={{ backgroundColor: 'rgb(48, 48, 48)' }}
					>
						<h4 className="modal-title" id="sendCapsBackModalLabel">
							Are you sure you want to remove {capturesCurrentlyInQC.length}{' '}
							captures from your pipeline?
						</h4>
						<button
							type="button"
							className="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
						></button>
					</div>

					<div className="modal-body">
						<h5>
							These captures are still assigned to you in the database.<br></br>
							<br></br>Please release them from your pipeline. They will be
							automatically released after 8 hours.
						</h5>
					</div>

					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-secondary"
							data-bs-dismiss="modal"
						>
							Close
						</button>
						<button
							type="button"
							className="btn interactButtonSecondary"
							data-bs-dismiss="modal"
							onClick={(e) => functionSendCapsBack()}
						>
							Remove all captures
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SendCapsBackModal;
